var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-dashboard',{attrs:{"range-id":_vm.resId,"range-type":"schedtags"}})}
var staticRenderFns = []

export { render, staticRenderFns }